<template>
  <div class="footer">
    <div class="footer-box center">
      <ul class="footer-header">
        <li v-for="(x, index) in items">
          <div class="title">{{ x.title }}</div>
          <ul
            class="footer-nav"
            v-show="index != 2"
            :class="{ index3: index == 1 }"
          >
            <li v-for="(y, index_) in x.list" @click="gotoPage(y, index_)">
              {{ y.name }}
            </li>

            <!-- <li v-if="index != 1" v-for="(y,index_) in x.list"  @click="gotoPage(y,index_)">{{y.name}}</li> -->
            <!-- <li v-if="index == 1" v-for="(y,index_) in x.list"><a href="https://www.yizhiniao.com/mall/#/login" target="_blank" style="color: #9B9B9B;">{{y.name}}</a></li> -->
          </ul>
          <div class="erweima" v-show="index == 2"><img src="" alt="" /></div>
        </li>
      </ul>
      <div class="footer-company clearfix">
        <div class="fl" style="display: flex;">
          <div class="footer-logo "></div>
          <div class="footer-logo2 "></div>
        </div>
        <div class="footer-info fl">
          <div class="title">联系我们</div>
          <p>
            <span>联系电话：0571-85789582 133-6289-3918</span>
            <span>公司地址：浙江省杭州市拱墅区湖州街567号北城天地</span>
          </p>
        </div>
      </div>
      <div class="footer-bottom">
        ©2017-{{ year }} 浙江筑森网络科技有限公司 ALL RIGHTS RESERVED.
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
          >浙ICP备17016508号</a
        >&nbsp;
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202001115"
          >浙公网安备33010202001115号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: "",
      items: [
        {
          title: "产品体系",
          list: [
            { name: "教培管理系统", link: "/product_jiaopei", parent: "1" },
            { name: "招生营销工具", link: "/product_zhaosheng", parent: "1" },
            { name: "便捷支付方式", link: "/product_pay", parent: "1" },
            { name: "家校服务平台", link: "/product_hservice", parent: "1" },
            { name: "刷脸签到点名", link: "/product_face", parent: "1" },
            { name: "线上课程教学", link: "/product_online", parent: "1" },
            { name: "打卡作业督学", link: "/product_onwork", parent: "1" }
          ]
        },
        // {
        //     title: "线上商城",
        //     list: [{ name: "易知家商城", link: "" }]
        // },
        {
          title: "关于我们",
          list: [
            {
              name: "品牌介绍",
              link: "/aboutUs_intro",
              parent: "7",
              top: "intro"
            },
            {
              name: "企业文化",
              link: "/aboutUs_intro",
              parent: "7",
              top: "culture"
            },
            {
              name: "企业荣誉",
              link: "/aboutUs_intro",
              parent: "7",
              top: "rongyu"
            },
            {
              name: "团队风采",
              link: "/aboutUs_intro",
              parent: "7",
              top: "team"
            },
            {
              name: "联系我们",
              link: "/aboutUs_intro",
              parent: "7",
              top: "concat"
            }
          ]
        },
        { title: "扫码关注易知鸟" }
      ],
      msg: "this is footer"
    };
  },
  created() {},
  mounted() {
    this.year = new Date().getFullYear();
  },
  methods: {
    gotoPage(x, ind) {
      if (x.parent) {
        this.$router.push({
          path: x.link,
          query: {
            fromId: "" + x.parent,
            parentId: x.parent
              ? x.parent != 6
                ? x.parent + "_" + ind
                : x.parent + "_1"
              : undefined,
            top: x.top
          }
        });
      } else {
        this.$router.push({
          path: x.link,
          query: {
            fromId: "" + ind
          }
        });
      }
      var query = this.$route.query;
      localStorage.setItem("current", JSON.stringify(query));
    }
  }
};
</script>

<style scoped lang="less">
.footer {
  width: 100%;
  height: 400px;
  background: #0d1020;
  color: #9b9b9b;

  .footer-box {
    padding: 0 85px;
    height: 100%;

    .footer-header {
      display: flex;
      justify-content: space-between;

      .title {
        margin: 42px auto 35px;
        text-align: left;
        color: #e3e3e3;
      }

      .footer-nav {
        width: 194px;
        height: 115px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
      }

      .footer-nav li {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 6px;
        text-align: left;
        cursor: pointer;
      }
      .footer-nav.index3 {
        height: 80px;
      }

      .erweima {
        width: 140px;
        height: 140px;
        padding: 10px;
        border: 1px solid;
        background: url(/static/img/common/erweima.png) no-repeat center;
      }
    }

    .footer-company {
      margin-top: 10px;
      padding-bottom: 13px;
      .footer-info {
        .title {
          text-align: left;
          font-size: 18px;
          color: #e3e3e3;
          margin-bottom: 5px;
        }

        p {
          span {
            display: inline-block;
            font-size: 14px;
            color: #9b9b9b;
          }

          span:nth-child(1) {
            margin-right: 20px;
          }
        }
      }

      .footer-logo {
        width: 127px;
        height: 40px;
        margin-right: 10px;
        background: url("/static/img/common/footerLogo.png") no-repeat center;
      }
      .footer-logo2 {
        width: 100px;
        height: 40px;
        // margin-left: 30px;
        margin-right: 30px;
        background: url("/static/img/common/logo2.png") no-repeat center;
        background-size: contain;
        filter: grayscale(1);
      }
    }

    .footer-bottom {
      padding-top: 20px;
      width: 100%;
      border-top: 1px solid #4a4a4a;
      color: #9b9b9b;
      font-size: 12px;
      text-align: left;

      a {
        color: #9b9b9b;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue